// extracted by mini-css-extract-plugin
export default {"reactionsContainer":"Reactions-module__reactionsContainer--II9mB"};